module.exports = __webpack_public_path__ + "img/policy-service.5404f893.svg";